export class IdValue<T = number, V = string, N = string> {
  id: T; // back-end value
  value: V; // optional.
  name: N; // display name
  constructor(id?: T, value?: V, name?: N) {
    this.id = id;
    this.value = value;
    this.name = name;
  }

  static fromEnum<T>(
    enumType: T,
    caseConversionFn = (camelCase) =>
      camelCase.toUpperCase() === camelCase
        ? camelCase
        : camelCase
            .replace(/([A-Z])/g, (match) => ` ${match}`)
            .replace(/^./, (match) => match.toUpperCase())
            .trim(),
  ) {
    return Object.keys(enumType)
      .filter((k) => isNaN(+k))
      .map(function (type) {
        const nameValue = caseConversionFn ? caseConversionFn(type) : type;
        return new IdValue(enumType[type], nameValue, nameValue);
      });
  }

  /**
   * Sorts IdValue items alphabetically by name.
   * Keeps items with null/undefined IDs (like "Select") at the top.
   */
  static sort(items: IdValue[]): IdValue[] {
    return items.sort((a, b) => {
      const aIsSelect = a.id === null || a.id === undefined;
      const bIsSelect = b.id === null || b.id === undefined;

      if (aIsSelect && !bIsSelect) {
        return -1;
      }
      if (!aIsSelect && bIsSelect) {
        return 1;
      }
      if (aIsSelect && bIsSelect) {
        return 0;
      }

      const nameA = a.name ? String(a.name).toLowerCase() : '';
      const nameB = b.name ? String(b.name).toLowerCase() : '';

      return nameA.localeCompare(nameB);
    });
  }
}
